import { HttpErrorResponse, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BadRequestHandler, GlobalMessageType } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class EbBadRequestHandler extends BadRequestHandler {
  protected handleValidationError(_request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.getErrors(response)
      .filter(e => e.type === 'ValidationError')
      .forEach(error => {
        if (error.reason === 'invalid' && error.subject === 'productCode') {
          //  request with decrypted productCode after session timeout --> should not lead to a page not found message
          this.globalMessageService.add(
            {
              key: 'httpHandlers.sessionExpired'
            },
            GlobalMessageType.MSG_TYPE_ERROR
          )
        } else {
          this.globalMessageService.add(
            {
              key: `httpHandlers.validationErrors.${error.reason}.${error.subject}`
            },
            GlobalMessageType.MSG_TYPE_ERROR
          )
        }
      })
  }
}
